import React, { useRef, useState } from 'react';
import { Button, Row, Col, Modal, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { connect } from 'react-redux';
import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { duotone, solid } from '@fortawesome/fontawesome-svg-core/import.macro';
import BlockUi from 'react-block-ui';
import Toastr from '../utils/toastr';
import useMonitorAPIService from '../../services/monitorapiservice';

function DeleteCorporateGroup(props) {

    const { t } = useTranslation();
    const toastrRef = useRef(null);
    const [loading, setLoading] = useState(false);
    const { removeCorporateGroup } = useMonitorAPIService();

    const deleteGroup = e => {
        setLoading(true);
        removeCorporateGroup(props.token,JSON.stringify(props.data.id), (res) => {
            props.toggleModal();
            setLoading(false);
        });
    }

    return (<>
        <Modal rtl={props.rtl} show={props.show} onHide={props.toggleModal} size="lg">
            <BlockUi tag="div" blocking={loading} color="#009ef7" message={t("pleasewait")}>
                <Modal.Header>
                    <Modal.Title>
                        <FontAwesomeIcon icon={duotone("triangle-exclamation")} /> {t("warning")}
                    </Modal.Title>
                    <OverlayTrigger
                        placement="left"
                        delay={{ show: 250, hide: 400 }}
                        overlay={<Tooltip style={{ position: "fixed" }}>
                            {t("close")}
                        </Tooltip>}>
                        <Button onClick={props.toggleModal} className='float-end'><FontAwesomeIcon icon={solid('xmark')} /></Button>
                    </OverlayTrigger>
                </Modal.Header>
                <Modal.Body>
                    <Row>
                        <Col>
                            <p>{t("abouttodelete")}</p>
                        </Col>
                    </Row>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="danger" onClick={deleteGroup}>
                        <FontAwesomeIcon icon={duotone("trash-can")} /> {t("delete")}
                    </Button>
                </Modal.Footer>
            </BlockUi>
        </Modal>
        <Toastr ref={toastrRef} />
    </>)
}

const mapStateToProps = (state) => {
    return {
        token: state.supervisor.token,
        rtl: state.parameters.rtl
    };
};

export default connect(mapStateToProps, {})(DeleteCorporateGroup);